import { ReactNode, forwardRef, LegacyRef } from 'react';
import { UiText } from '@frontend/znanie-uikit';
import cn from 'classnames';
import { useReactiveVar } from '@apollo/client';

import { themeVar } from 'store/theme';

import { snakeToCamelCase } from 'utils/helpers';

import css from './HtmlContent.module.scss';

interface IProps {
  html: string | ReactNode;
  truncate?: boolean;
  size?: number;
  char?: string;
  hashChanged?: boolean;
  onClickMore?(isOpen: boolean): void;
}

const HtmlContent = forwardRef(
  (
    {
      html,
      truncate,
      size = 1000,
      char = '',
      onClickMore,
      hashChanged = true,
    }: IProps,
    ref: LegacyRef<HTMLDivElement>
  ) => {
    const { name: themeName } = useReactiveVar(themeVar);

    if (typeof html !== 'string') {
      return <div className={css.block}>{html}</div>;
    }

    return (
      <>
        {truncate && !hashChanged ? (
          <div
            className={cn(
              css.block,
              css[snakeToCamelCase(`block_${themeName}`)]
            )}
            ref={ref}
          >
            <UiText.Wrapper
              size={size}
              withFormat
              isBlur
              theme={themeName}
              char={char}
              onClickMore={onClickMore}
            >
              {html}
            </UiText.Wrapper>
          </div>
        ) : (
          <div
            className={cn(
              css.block,
              css[snakeToCamelCase(`block_${themeName}`)]
            )}
            dangerouslySetInnerHTML={{ __html: html }}
            ref={ref}
          />
        )}
      </>
    );
  }
);

export default HtmlContent;
